export const STATS_BRANDS = 'STATS_BRANDS';
export const STATS_REPLENISH = 'STATS_REPLENISH';
export const STATS_TOTALS = 'STATS_TOTALS';
export const STATS_BRANDS_LOADING = 'STATS_BRANDS_LOADING';
export const SET_CURRENT_FILTER_RANGE = 'SET_CURRENT_FILTER_RANGE';

export const SUPPLIER_STATS_DATA = 'SUPPLIER_STATS_DATA';
export const SUPPLIER_STATS_LOADING = 'SUPPLIER_STATS_LOADING';
export const SUPPLIER_STATS_RETAILERS = 'SUPPLIER_STATS_RETAILERS';
